import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
    Button,
    Card,
    CardHeader,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    Table,
    UncontrolledDropdown,
} from "reactstrap";
import ReviewContactService from "../../../services/reviewContactService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import FormInput from "../../../components/common/form/FormInput";
import _ from "lodash";
import formatFrontendDate from "../util/formatFrontendDate";
import ReviewService from "../../../services/reviewService";
import Loader from "../../Loader";

class UnansweredContacts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            alert: null,
            filterName : "",
            filterSurname :"",
            filterCompany : "",
            filteredList : [],
            audienceList: new Set(),
            userSettings: null,
            loading:false
        };
        this.delete = this.delete.bind(this);
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
        ReviewService.unansweredContacts().then((response) => {
            this.setState({list: response, filteredList : response});
            console.log(this.state.filteredList);
        });
        ReviewService.fetchSettingForUser().then(response => {
            this.setState({userSettings: response});
            console.log(response)
        })
    }

    onChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
        console.log(this.state);
    }

    applyFilter = () => {
        const { list, filterName, filterSurname, filterCompany } = this.state;

        const filteredList = _.filter(list, (contact) => {
            const nameMatches = filterName ? _.includes(_.toLower(contact.firstName), _.toLower(filterName)) : true;
            const surnameMatches = filterSurname ? _.includes(_.toLower(contact.lastName), _.toLower(filterSurname)) : true;
            const companyMatches = filterCompany ? _.includes(_.toLower(contact.company.legalName), _.toLower(filterCompany)) : true;

            return nameMatches && surnameMatches && companyMatches;
        });

        this.setState({ filteredList : filteredList });
    }

    clearFilter = () => {
        this.setState({filteredList : this.state.list, filterName : "", filterSurname : "", filterCompany : "" })
    }

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    };

    confirmDeleteAlert = (uniqueId) => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{display: "block"}}
                    title="Are you sure?"
                    onConfirm={() => this.delete(uniqueId)}
                    onCancel={this.hideDeleteAlert}
                    showCancel
                    confirmBtnBsStyle="danger"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnBsStyle="secondary"
                    cancelBtnText="Cancel"
                    btnSize=""
                >
                    You won't be able to revert this!
                </ReactBSAlert>
            )
        });
    };

    toggleContactSelection = (uniqueId) => {
        const { audienceList } = this.state;
        let updatedAudienceList = new Set(audienceList);

        if (updatedAudienceList.has(uniqueId)) {
            updatedAudienceList.delete(uniqueId);
        } else {
            updatedAudienceList.add(uniqueId);
        }

        this.setState({ audienceList: updatedAudienceList });
        console.log(this.state.audienceList);
    };

    delete(uniqueId) {
        this.setState({alert: null})
        ReviewContactService.delete(uniqueId).then((response) => {
            console.log(response);
            this.notify(
                response.responseStatus.toLowerCase(),
                response.responseStatus,
                response.message
            );
            //TODO: TO be fixed with redux implementation
            //   this.props.history.push("/admin/dashboard");
            ReviewContactService.list().then((response) => {
                console.log(response);
                this.setState({list: response, filteredList : response});
            });
        });
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };
    createReviews = () => {

        console.log(this.state.audienceList)
        if(this.state.userSettings === null){
            this.notify("error","Error", "Please set your survey type in settings first!")
            return;
        }
        if(this.state.audienceList.size === 0){
            this.notify("danger","Validation", "Please select at least one contact for the audience list!")
            return;
        } else{
            this.setState({loading: true});
            const data = {
                audienceList: [...this.state.audienceList]
            }
            ReviewService.createReviewCampaign(data).then((response) => {
                console.log(response);
                this.setState({loading: false});
                this.notify("success","Success", "Your review Campaign has been created Successfully! Contacts will be notified shortly!")
            })
        }
    }


    render() {
        let obj = this;
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {this.state.loading ? (<Loader/>) : ("")}
                <SimpleHeader
                    name="List"
                    parentName="UnAnswered "
                    heading="XareGrwoth"
                    /*newBtnUrl="/user/contact/create"
                    newBtnText="Create Review Contact"*/
                />
                {this.state.alert}
                <Container className="mt--6" fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0">UnAnswered Contacts List
                                                {/*<div style={{ float: "right" }}>
                                                    <Button
                                                        outline
                                                        color="default"
                                                        size="sm"
                                                        onClick={(e) => {
                                                            this.createReviews()
                                                        }}
                                                    >
                                                        Send Reviews ({this.state.audienceList.size || 0})
                                                    </Button>
                                                </div>*/}
                                            </h3>

                                        </div>
                                    </Row>
                                    <Row>
                                        <p style={{ fontStyle: "italic", color: "gray" }}>
                                            Use the filters below to narrow down your search results.
                                        </p>
                                    </Row>
                                    <Row>
                                        {/*<Col sm={2}>
                        <FormInput
                            name="dateFrom"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateFrom || ""}
                            label="Date From"
                        />
                      </Col>
                      <Col sm={2}>
                        <FormInput
                            name="dateTo"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateTo || ""}
                            label="Date To"
                        />
                      </Col>*/}
                                        <Col md="2">
                                            <FormInput
                                                name="filterName"
                                                className="form-control-label"
                                                id="name"
                                                placeholder="Name"
                                                type="text"
                                                onChange={this.onChange}
                                                label="Name"
                                                value={this.state?.filterName || ""}
                                                // errorMsg={this.props.errorObj?.name || ""}
                                            />
                                        </Col>
                                        <Col md="2">
                                            <FormInput
                                                name="filterSurname"
                                                className="form-control-label"
                                                id="countryName"
                                                placeholder="Surname"
                                                type="text"
                                                onChange={this.onChange}
                                                label="Surname"
                                                value={this.state?.filterSurname || ""}
                                                // errorMsg={this.props.errorObj?.name || ""}
                                            />
                                        </Col>
                                        <Col md="2">
                                            <FormInput
                                                name="filterCompany"
                                                className="form-control-label"
                                                id="companyName"
                                                placeholder="Company Name"
                                                type="text"
                                                onChange={this.onChange}
                                                label="Company Name"
                                                value={this.state?.filterCompany || ""}
                                                // errorMsg={this.props.errorObj?.name || ""}
                                            />
                                        </Col>
                                        <Col md={"2"}></Col>
                                        <Col sm={3} style={{marginTop: "30px"}}>
                                            <Button  size="md" outline color="default" type="button"
                                                     onClick={this.applyFilter}
                                            >
                                                Apply Filter
                                            </Button>
                                            <Button  color="default"  size="md" outline type="button"
                                                     onClick={this.clearFilter}
                                            >
                                                Clear Filter
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                    <tr>
                                        <th className="sort" data-sort="name" scope="col">
                                            #
                                        </th>
                                        <th className="sort" data-sort="budget" scope="col">
                                            Date Created
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            First Name
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Last Name
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Title
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Company Name
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Contact Role
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Email Address
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Contact Number
                                        </th>
                                        <th scope="col"/>
                                    </tr>
                                    </thead>
                                    <tbody className="list">
                                    {this.state.filteredList.map((value, index) => {
                                        return (
                                            <tr key={index} /*style={{display: ContactPermissions.read()}}*/>
                                                {/*<td>
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.audienceList.has(value.uniqueId)}
                                                        onChange={() => obj.toggleContactSelection(value.uniqueId)}
                                                    />
                                                </td>*/}
                                                <td className="budget">{index + 1}</td>
                                                <td className="budget">{formatFrontendDate(value.dateCreated)}</td>
                                                <td className="budget">{value.firstName}</td>
                                                <td className="budget">{value.lastName}</td>
                                                <td className="budget">{value.title}</td>
                                                <td className="budget">{value.company.legalName}</td>
                                                <td className="budget">{value.contactRole}</td>
                                                <td className="budget">{value.email || "N/A"}</td>
                                                <td className="budget">{value.number || "N/A"}</td>
                                                <td className="text-right">
                                                    {/*<UncontrolledDropdown>
                                                        <DropdownToggle
                                                            color=""
                                                            size="sm"
                                                            className="btn-icon-only text-light"
                                                        >
                                                            <i className="fas fa-ellipsis-v"/>
                                                        </DropdownToggle>
                                                        <DropdownMenu
                                                            className="dropdown-menu-arrow"
                                                            right
                                                        >
                                                            <DropdownItem
                                                                // style={{display:ContactPermissions.read()}}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.props.history.push(
                                                                        `/user/contact/show/${value.uniqueId}`
                                                                    );
                                                                }}
                                                            >
                                                                Details
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                // style={{display:ContactPermissions.update(value.createdBy)}}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.props.history.push(
                                                                        `/user/contact/edit/${value.uniqueId}`
                                                                    );
                                                                }}
                                                            >
                                                                Edit
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                // style={{display:ContactPermissions.delete()}}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.confirmDeleteAlert(`${value.uniqueId}`);
                                                                }}
                                                            >
                                                                Delete
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>*/}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default UnansweredContacts;
